import React from 'react';
import { Bell, Info } from 'lucide-react';

const NotificationsWidget = () => {
  const notifications = [
    { id: 1, message: 'IA Test 2 results published', time: '2 hours ago', type: 'info' },
    { id: 2, message: 'Attendance below 75%', time: '1 day ago', type: 'warning' },
  ];

  return (
    <div className="space-y-3">
      {notifications.length === 0 ? (
        <div className="text-center py-8">
          <Bell className="w-12 h-12 mx-auto mb-2 text-gray-300" />
          <p className="text-gray-500">No new notifications</p>
        </div>
      ) : (
        notifications.map(notif => (
          <div key={notif.id} className="p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start space-x-3">
            <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm text-gray-900">{notif.message}</p>
              <p className="text-xs text-gray-500 mt-1">{notif.time}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default NotificationsWidget;
